// Jan 1, 2020 - there should not be any trqkSongs in our system that have a creation date earlier
// than this
const earliestUnixDate = 1577865600;

/**
 * Several data objects in the Trqk API use the Unix epoch timestamp as their first ten characters.
 * Given such an ID, return the number of milliseconds since the Unix epoch when the data was
 * created. This can be used to instantiate a JavaScript Date that represents the moment the data
 * was created.
 * @param trqkSongId - the song ID
 */
export const getCreatedAtFromId = (id: Maybe<string>): Maybe<number> => {
    if (id === null || id.length < 10) {
        return null;
    }

    let idInteger = 1;

    try {
        idInteger = parseInt(id.slice(0, 10), 10);
    } catch {
        // If we can't parse the first ten characters to an integer, return null
        return null;
    }

    if (Number.isNaN(idInteger)) {
        return null;
    }

    if (idInteger < earliestUnixDate) {
        // If the first ten characters parse into an integer that is too early to be plausible,
        // return null
        return null;
    }

    const time = idInteger * 1000;

    if (time > Date.now()) {
        // If the first ten characters parse into an integer that is too late to be plausible,
        // return null
        return null;
    }

    // Otherwise, return the Unix timestamp (which is in seconds) times 1000
    return idInteger * 1000;
};
